import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Outlet, useLocation, useNavigate
} from 'react-router-dom';
import { withLang } from '../../i18n';
import { routes } from '../../constants';
import TabPane from '../TabPane';
import TabsContainer from '../TabsContainer';

const SurveySchemas = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.pathname === routes.surveySchemas.index) {
      navigate(routes.surveySchemas.schemas.index, { replace: true });
    }
  }, [location]);
  const routesWithTabs = [
    routes.surveySchemas.schemas.index,
    routes.surveySchemas.surveyParts.index,
    routes.surveySchemas.extraSurveyParts.index
  ];
  const showTabs = routesWithTabs.some((route) => location.pathname === route);
  const t = props.translate;
  return (
    <div>
      {showTabs ? (
        <div className="page-container">
          <h1>{t('surveySchemas.title')} </h1>
          <TabsContainer key={window.location.pathname}>
            <TabPane label={t('links.surveySchemas')} icon="icon--item-set" route="/schemas" dataCy="survey-schemas-tab">
              <Outlet />
            </TabPane>
            <TabPane label={t('surveySchemaParts.schemaParts')} icon="icon--item-single" route="/survey-parts">
              <Outlet />
            </TabPane>
            <TabPane label={t('extraSurveyParts.title')} icon="icon--item-single" route="/extra-survey-parts">
              <Outlet />
            </TabPane>
          </TabsContainer>
        </div>
      ) : <Outlet />}
    </div>
  );
};

const { func } = PropTypes;
SurveySchemas.propTypes = {
  translate: func.isRequired
};

export default withLang(SurveySchemas);
